import { Box, Typography, List } from '@mui/material';
import React from 'react';
import { useDeviceDetails } from '../../data/DataProviders/DeviceDetailsProvider';
import { sortObjectArrayNaturally } from '../../lib';
import { isDataLoaded, Status } from '../../types';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { DataIndicators } from '../DataIndicators';
import { FlatListItem } from '../FlatListItem/FlatListItem';
import { Device } from '../../api/types';

export const PxChildDeviceList: React.FC<{ childDeviceData: any[]; parentDeviceId: string }> = (props) => {
    const deviceDetails = useDeviceDetails();
    const currentAppRoute = useCurrentAppRoute();
    const isChildDeviceDataEmpty = props.childDeviceData ? props.childDeviceData.length === 0 : false;
   
    const [childDeviceList, setChildDeviceList] = React.useState<Device[]>([]);

    React.useEffect(() => {
        if (props.childDeviceData)  {
            setChildDeviceList(props.childDeviceData);
        }
    }, [props.childDeviceData]);

    return (
        <>
            {isDataLoaded(deviceDetails) && deviceDetails.value.devices.length === 0 && (
                <Typography variant="h6" color="primary" style={{ marginBottom: 24 }}>
                    {`Devices (0)`}
                </Typography>
            )}
            <DataIndicators
                errorMessage="No Devices found"
                emptyMessage="No Devices found"
                data={deviceDetails}
                emptyIcon="Device"
                isEmpty={isChildDeviceDataEmpty}
                withAction={true}
                description="Devices that cannot connect directly to the Eaton Cloud can be added here. These Devices communicate with a Connected Device, which then connects to the Eaton Cloud."
            />
            {(props.childDeviceData) &&
                props.childDeviceData.length > 0 &&
                currentAppRoute.type === 'PxDeviceProfile' && (
                    <>
                        <Box display="flex" justifyContent="space-between" style={{ padding: 16, paddingTop: 0 }}>
                            <Typography variant="h6" color="primary" data-testid="child-delete-count">
                                {`Devices (${props.childDeviceData.length})`}
                            </Typography>
                        </Box>
                        {childDeviceList &&
                            <List data-testid="device-item">
                                {sortObjectArrayNaturally(childDeviceList, [{ sortField: 'name' }]).map(
                                    (device: Device) => (
                                        <FlatListItem
                                            key={device.id}
                                            item={{
                                                id: device.id,
                                                name: device.name || '',
                                                status: device.status ? Status.Online : Status.Offline,
                                                isEditable: false,
                                                type: 'PxChildDeviceProfile',
                                                parentId :device.parentDeviceId || '',
                                            }}
                                            subTitleData={`${device.vendor} ${device.model}|${device.family}`}
                                            hasStatus={true}
                                            navigate={{
                                                type: 'PxChildDeviceProfile',
                                                deviceId: props.parentDeviceId,   
                                                locationId: currentAppRoute.locationId,
                                                orgId: currentAppRoute.orgId,
                                                siteId: currentAppRoute.siteId,
                                                childDeviceId: device.id,
                                            }}
                                        ></FlatListItem>
                                    )
                                )}
                            </List>
                        }
                    </>
                )}
        </>
    );
};
